import { TaxPricingController } from '../types/AvantArteProduct';
import {
  GeneratedTaxType,
  useGetTaxesByCountryCodeQuery,
} from '../types/generated';
import { CountryCode } from '../types/Locations';
import { useCountryCode } from './useCountryCode';

interface Props {
  countryCode?: CountryCode;
  skip?: boolean;
}

export function useTaxPricing({
  countryCode,
  skip,
}: Props): TaxPricingController {
  const [userPreferencesCountryCode] = useCountryCode();
  const { data: taxData, loading } = useGetTaxesByCountryCodeQuery({
    variables: {
      countryCode: countryCode || userPreferencesCountryCode,
    },
    skip,
  });
  const taxes = taxData?.getTaxesByCountryCode;

  const calculateTaxPricing = (price: number) => {
    if (taxes?.taxType === GeneratedTaxType.Vat)
      return (price * (taxes.vatRate + 100)) / 100;

    return price;
  };

  return {
    calculateTaxPricing,
    loading,
    taxes,
  };
}
